@if (fields) {
  <span>
    @for (field of fields ; track field; let first = $first; let last = $last) {
      <span>
        @if (!first && !last) {
          <span>,</span>
        }
        @if (!first && last) {
          <span> and </span>
        }
        a <strong [matTooltip]="getFieldDescription(field)">{{getFieldName(field)}}</strong>
      </span>
    }
  </span>
}
